// extracted by mini-css-extract-plugin
module.exports = {"property":"Property_property__P41s9","propertyNumber":"Property_propertyNumber___svvI"};